import {
  Component,
  OnInit,
} from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { AuthService } from "src/app/core/service/auth.service";
import { TokenStorageService } from "src/app/core/service/token-storage.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";

@Component({
  selector: 'app-church-welcome-widget',
  templateUrl: './church-welcome-widget.component.html',
  styleUrls: ['./church-welcome-widget.component.sass']
})
export class ChurchWelcomeWidgetComponent 
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  churchLogo: SafeUrl | string = 'assets/images/Caritas.jpg';
  officerName: string = '';
  churchName: string = '';
  churchUnitCode: string = '';


  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private tokenStorage: TokenStorageService
  ) {
    super();
  }
  

  ngOnInit() {    const currentUser = this.tokenStorage.getUser();

    this.officerName = `${currentUser.firstName || ''} ${currentUser.lastName || ''}`.trim();
    this.getChurchProfile();

    const churchUnitId = currentUser.parishId;
    if (churchUnitId) {
      this.getChurchUnitCode(churchUnitId);
    }
  }

 
  getChurchUnitCode(churchUnitId: number) {
    this.authService.getChurchUnit(churchUnitId).subscribe(
      (response: any) => {
        this.churchUnitCode = response?.entity?.churchUnitCode || '';
      },
      (error) => {
        console.error('Error fetching church unit:', error);
      }
    );
  }

  getChurchProfile() {
    const churchId = this.tokenStorage.getUser()?.parishId;
    if (!churchId) return;

    this.authService.getChurchProfilebyId(churchId).subscribe({
      next: (data) => {
        const logoBase64 = data?.entity?.logo;

        if (logoBase64) {
          const cleanedBase64 = logoBase64.replace(/^data:image\/[a-z]+;base64,/, '').trim();
          const mimeType = logoBase64.startsWith('data:image/png') ? 'image/png' : 'image/jpeg';

          this.churchLogo = this.sanitizer.bypassSecurityTrustUrl(
            `data:${mimeType};base64,${cleanedBase64}`
          );
        } else {
          this.churchLogo = 'assets/images/Caritas.jpg';
        }

        this.churchName = data?.entity?.churchName || 'Church Management System';
      },
      error: (err) => {
        console.error("Error fetching church profile:", err);
        this.churchLogo = 'assets/images/Caritas.jpg';
      }
    });
  }
}

